import { Node, mergeAttributes, Command, CommandProps } from '@tiptap/core'

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    pageBreak: {
      insertPageBreak: () => ReturnType
    }
  }
}

export const PageBreak = Node.create({
  name: 'pageBreak',

  group: 'block',
  atom: true,
  selectable: true,

  parseHTML() {
    return [
      { tag: 'hr[data-page-break]' },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-page-break': 'true', class: 'page-break' })]
  },

  addCommands() {
    return {
      insertPageBreak: (): Command => ({ tr, dispatch }) => {
        const node = this.type.create()
        const { from } = tr.selection

        if (dispatch) {
          tr.insert(from, node)
        }

        return true
      },
    }
  },
})
